
const error = function(texto){
  return `<span class="text-danger-soft erro-minuta" style="color: red;">$(${texto})</span>`;
};

export default error;
